import { useMemo } from 'react';

import { useGetAccountItems } from ':cloud/queries/BillingQueries/useGetAccountItems';
import { useGetUser } from ':cloud/queries/UserQueries/useGetUser';

function useMostRecentAccountItem() {
  const { activeOrg } = useGetUser();
  const { accountItems } = useGetAccountItems(activeOrg?.organizationId);
  return useMemo(
    () =>
      accountItems?.length
        ? accountItems.sort(
            (item1, item2) =>
              new Date(item2.createTime).getTime() - new Date(item1.createTime).getTime(),
          )[0]
        : undefined,
    [accountItems],
  );
}

export default useMostRecentAccountItem;
